/** Helper dùng chung cho chuông + trang thông báo (plan 2026-10-03 §1). */
import { useNavigate } from "react-router-dom";
import { type AppNotification, useMarkRead } from "@/api/notifications";

export const CATEGORY_COLORS: Record<string, string> = {
  deadline: "orange",
  grade: "green",
  forum: "blue",
  announcement: "purple",
  registration: "cyan",
  appeal: "magenta",
  system: "default",
};

export function useOpenNotification() {
  const navigate = useNavigate();
  const markRead = useMarkRead();
  return (item: AppNotification) => {
    if (!item.read_at) markRead.mutate(item.id);
    if (item.link_url) navigate(item.link_url);
  };
}
